module.exports = __webpack_public_path__ + "static/hexomatic-vs-all-0012cfd9d66eda287c31ce093cd398a8.png";